export default {
  root: {
    "&$focused": {
      color: "#ffffff",
    },
  },
};
